import { render } from "./ModalSolicitacao.vue?vue&type=template&id=2ac32122&scoped=true"
import script from "./ModalSolicitacao.vue?vue&type=script&lang=js"
export * from "./ModalSolicitacao.vue?vue&type=script&lang=js"

import "./ModalSolicitacao.vue?vue&type=style&index=0&id=2ac32122&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac32122"]])

export default __exports__